import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pen-man/pen-man/app/_contexts/AppWithProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LicenseProvider"] */ "/home/runner/work/pen-man/pen-man/app/_contexts/LicenseProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pen-man/pen-man/app/_store/ReduxProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pen-man/pen-man/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/home/runner/work/pen-man/pen-man/node_modules/nuqs/dist/adapters/next/app.js");
